import type { Reducer } from 'redux';

import type { MyLeaderSponsoredCampaignsLoadAction } from '../../domains/myLeaderSponsoredCampaigns/actions.types';

import type { MyLeaderSponsoredCampaigns, MyLeaderSponsoredCampaignsFields } from './types';

export type MyLeaderSponsoredCampaignsAction = MyLeaderSponsoredCampaignsLoadAction;

const initialMyLeaderSponsoredCampaigns: MyLeaderSponsoredCampaigns = {
  campaignIds: [],
  status: 'notRequested',
};

const setPending = (state: MyLeaderSponsoredCampaigns): MyLeaderSponsoredCampaigns => ({
  ...state,
  status: 'pending',
});

const setRejected = (state: MyLeaderSponsoredCampaigns): MyLeaderSponsoredCampaigns => ({
  ...state,
  status: 'rejected',
});

const loadSuggestedCampaignsFulfilled = (
  state: MyLeaderSponsoredCampaigns,
  data: MyLeaderSponsoredCampaignsFields
): MyLeaderSponsoredCampaigns => ({
  ...state,
  ...data,
  status: 'fulfilled',
});

const reducer: Reducer<MyLeaderSponsoredCampaigns, MyLeaderSponsoredCampaignsAction> = (
  state = initialMyLeaderSponsoredCampaigns,
  action
) => {
  switch (action.type) {
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_PENDING':
      return setPending(state);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_REJECTED':
      return setRejected(state);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return loadSuggestedCampaignsFulfilled(state, action.payload.entities.myLeaderSponsoredCampaigns);
    default:
      return state;
  }
};

export default reducer;
